<template>
  <div class="toolsPanelList">
    <div class="toolsPanelList__title">
      <span>Workflows:</span>
    </div>
    <ul v-if="Object.keys(workflows)" class="toolsPanelList__list">
      <li v-for="(item, key) in workflows" :key="key" class="toolsPanelList__listItem">
        <a href="#" @click.prevent="show(key)">{{ item ? item.name : null }}</a>
        <a href="#" class="toolsPanelList__removeListItem" @click.prevent="remove(key)">
          <icon name="remove" />
        </a>
      </li>
    </ul>
    <div>
      <b-button class="toolsPanelList__addBtn" @click="createWorkflow" variant="primary" size="sm">
        <icon name="plus" />
        <span>Create</span>
      </b-button>
    </div>
    <CreateWorkflowModal ref="createWorkflowModal" @created="add()" />
  </div>
</template>

<script>
// services
import db from '@/services/db'
// components
import CreateWorkflowModal from './modals/CreateWorkflow'
// helpers
import eventBus from '@/helpers/event-bus'

export default {
  components: {
    CreateWorkflowModal,
  },
  data() {
    return {
      workflows: [],
    }
  },
  methods: {
    createWorkflow() {
      this.$refs.createWorkflowModal.open()
    },
    add() {
      this.workflows = Object.assign({}, this.workflows)
    },
    show(key) {
      eventBus.$emit('showWorkflow', key)
    },
    remove(key) {
      if (!confirm('Are you sure?')) return

      db.workflow.remove(key, () => {
        delete this.workflows[key]

        this.workflows = Object.assign({}, this.workflows)

        if (!Object.keys(this.workflows).length) {
          eventBus.$emit('showWorkflow', null)
        }
      })
    },
  },
  created() {
    const workflows = this.$store.state.workflows

    if (Object.keys(workflows).length) {
      this.workflows = workflows
    }

    db.workflow.read(items => {
      this.workflows = workflows ? workflows : null

      if (this.workflows) return

      for (let key in this.workflows) {
        let data

        try {
          data = JSON.parse(this.workflows[el].data)
        } catch (e) {
          data = []
        }

        this.$store.commit('setWorkflows', {
          id: key,
          data,
          name: this.workflows[key].name,
        })
      }
    })
  },
}
</script>
